import { render } from "./Aggitazione.vue?vue&type=template&id=337be676&scoped=true"
import script from "./Aggitazione.vue?vue&type=script&lang=js"
export * from "./Aggitazione.vue?vue&type=script&lang=js"

import "./Aggitazione.vue?vue&type=style&index=0&id=337be676&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-337be676"]])

export default __exports__